import { List } from "@mantine/core"

const MantineList = (props: any) => {
    const { children, className, spacing, center, type, withPadding, listStyleType } = props
    return (
        <List className={className} type={type} spacing={spacing} center={center || false} withPadding={withPadding || false} listStyleType={listStyleType}>
            {children}
        </List>
    )
}

const MantineListItem = (props: any) => {
    const { children, icon, className, key, onClick} = props
    return (
        <List.Item
            icon={icon}
            className={className} key={key} onClick={onClick}>{children}</List.Item>
    )

}
export { MantineList, MantineListItem }